import { SettingsObject } from '@hooks/useSettings';

export const defaults: Partial<SettingsObject> = {
    currency: 'CAD',
    includeVAT: false,
    measurement: 'both',
};
